import React, { ReactElement } from 'react';

import {
    IconAlertCircle,
    IconAlertTriangle,
    IconNoParties,
    IconNoPets,
    IconNoSmoking,
    IconPetRules,
    IconRuleUser,
    IconVolumeX,
} from '../../assets/icons';
import { RulesIconKey } from '../../types/rentalAgreement';

export const getHouseRuleIconByKey = (key: RulesIconKey): ReactElement => {
    switch (key) {
        case RulesIconKey.ALERT_CIRCLE:
            return <IconAlertCircle />;
        case RulesIconKey.ALERT_TRIANGLE:
            return <IconAlertTriangle />;
        case RulesIconKey.NO_PETS:
            return <IconNoPets />;
        case RulesIconKey.USER:
            return <IconRuleUser />;
        case RulesIconKey.NO_SMOKING:
            return <IconNoSmoking />;
        case RulesIconKey.NO_PARTIES:
            return <IconNoParties />;
        case RulesIconKey.VOLUME_X:
            return <IconVolumeX />;
        case RulesIconKey.ALLOWS_PETS:
            return <IconPetRules />;
        case RulesIconKey.DEFAULT:
            return <IconAlertCircle />;
        default:
            return <IconAlertCircle />;
    }
};
